(function() {

  const openProductModalBtn = document.querySelectorAll('[data-open-product-modal]');
  const productModalContainer = document.querySelector('[data-product-modal-container]');
  const productJson = JSON.parse(document.querySelector('[data-product-opens-modal-json]').innerHTML);

  init();

  function init() {
    openProductModalBtn.forEach((btn) => {
      btn.addEventListener('click', renderProductModal);
    });
  }

  function renderProductModal(event) {
    var target = event.target.closest('[data-product-opens-modal]');
    var id = parseFloat(target.dataset.productOpensModal);
    
    if (isNaN(id)) return;

    var handle = productJson.find((item) => item && item.current_variant_id === id).handle;

    window
      .fetch(`${window.theme.routes.root_url}products/${handle}?section_id=api-product-modal`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        // handle success
        const fresh = document.createElement('div');
        fresh.innerHTML = response;
        productModalContainer.innerHTML = fresh.querySelector('[data-api-content]').innerHTML;

        productModalContainer.querySelector('[data-product-modal-close]').addEventListener('click', closeProductModal);
        productModalContainer.addEventListener('click', handleClickOutsideModal)
        
        openProductModal();
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  /*------- Helpers -------*/

  function openProductModal() {
    productModalContainer.classList.add('is-visible');
  }

  function closeProductModal() {
    productModalContainer.classList.remove('is-visible');
  }

  function handleClickOutsideModal(event) {
    const productModal = productModalContainer.querySelector('[data-product-modal]');
    if (!productModal.contains(event.target)) {
      closeProductModal();
    }
  }

})();